package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Christmas Island Flag (16x12dp)
 *
 * - ISO Alpha-2: CX
 * - ISO Alpha-3: CXR
 * - ISO Numeric: 162
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.ChristmasIsland: ImageVector by lazy {
    ImageVector.Builder(
        name = "Christmas Island:CX:CXR:162:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4141DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                lineTo(16f, 12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3f, 4.5f)
                lineTo(2.5f, 4.866f)
                lineTo(2.567f, 4.25f)
                lineTo(2f, 4f)
                lineTo(2.567f, 3.75f)
                lineTo(2.5f, 3.134f)
                lineTo(3f, 3.5f)
                lineTo(3.5f, 3.134f)
                lineTo(3.433f, 3.75f)
                lineTo(4f, 4f)
                lineTo(3.433f, 4.25f)
                lineTo(3.5f, 4.866f)
                lineTo(3f, 4.5f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2f, 7.5f)
                lineTo(1.5f, 7.866f)
                lineTo(1.567f, 7.25f)
                lineTo(1f, 7f)
                lineTo(1.567f, 6.75f)
                lineTo(1.5f, 6.134f)
                lineTo(2f, 6.5f)
                lineTo(2.5f, 6.134f)
                lineTo(2.433f, 6.75f)
                lineTo(3f, 7f)
                lineTo(2.433f, 7.25f)
                lineTo(2.5f, 7.866f)
                lineTo(2f, 7.5f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4f, 10.5f)
                lineTo(3.5f, 10.866f)
                lineTo(3.567f, 10.25f)
                lineTo(3f, 10f)
                lineTo(3.567f, 9.75f)
                lineTo(3.5f, 9.134f)
                lineTo(4f, 9.5f)
                lineTo(4.5f, 9.134f)
                lineTo(4.433f, 9.75f)
                lineTo(5f, 10f)
                lineTo(4.433f, 10.25f)
                lineTo(4.5f, 10.866f)
                lineTo(4f, 10.5f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.5f, 5.75f)
                lineTo(4.25f, 5.933f)
                lineTo(4.283f, 5.625f)
                lineTo(4f, 5.5f)
                lineTo(4.283f, 5.375f)
                lineTo(4.25f, 5.067f)
                lineTo(4.5f, 5.25f)
                lineTo(4.75f, 5.067f)
                lineTo(4.717f, 5.375f)
                lineTo(5f, 5.5f)
                lineTo(4.717f, 5.625f)
                lineTo(4.75f, 5.933f)
                lineTo(4.5f, 5.75f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.781f, 6.112f)
                curveTo(10.594f, 5.917f, 12.276f, 5.459f, 12.45f, 4.868f)
                curveTo(12.681f, 4.354f, 12.527f, 3.937f, 11.654f, 3.571f)
                curveTo(10.781f, 3.205f, 9.898f, 2.497f, 10.913f, 2.497f)
                curveTo(11.927f, 2.497f, 11.927f, 2.642f, 12.2f, 3.069f)
                curveTo(12.473f, 3.495f, 13.062f, 3.587f, 13.074f, 3.069f)
                curveTo(13.074f, 2.186f, 13.158f, 2.067f, 12.445f, 1.299f)
                curveTo(11.732f, 0.532f, 14.232f, 1.615f, 14.025f, 2.93f)
                curveTo(13.819f, 4.246f, 13.57f, 3.822f, 13.728f, 4.043f)
                curveTo(13.886f, 4.264f, 14.836f, 3.578f, 14.717f, 4.491f)
                curveTo(14.385f, 5.017f, 13.726f, 5.798f, 10.781f, 6.112f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8f, 8.5f)
                curveTo(9.381f, 8.5f, 10.5f, 7.381f, 10.5f, 6f)
                curveTo(10.5f, 4.619f, 9.381f, 3.5f, 8f, 3.5f)
                curveTo(6.619f, 3.5f, 5.5f, 4.619f, 5.5f, 6f)
                curveTo(5.5f, 7.381f, 6.619f, 8.5f, 8f, 8.5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF548650)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.476f, 5.081f)
                curveTo(6.76f, 5.018f, 7.148f, 5.777f, 7.848f, 5.492f)
                curveTo(8.548f, 5.208f, 8.694f, 4.664f, 9.026f, 4.863f)
                curveTo(9.359f, 5.062f, 9.402f, 5.541f, 9.181f, 5.782f)
                curveTo(8.959f, 6.023f, 8.583f, 6.08f, 8.583f, 6.384f)
                curveTo(8.583f, 6.688f, 8.51f, 7.774f, 8.366f, 7.459f)
                curveTo(7.935f, 7.11f, 8.198f, 6.553f, 7.668f, 6.384f)
                curveTo(7.137f, 6.215f, 6.815f, 6.221f, 6.423f, 6.292f)
                curveTo(6.032f, 6.363f, 6.686f, 6.096f, 6.825f, 5.842f)
                curveTo(7.107f, 5.57f, 6.347f, 5.171f, 6.476f, 5.081f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun ChristmasIslandPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.ChristmasIsland,
            contentDescription = "Christmas Island Flag"
        )
    }
}
